type Column = {
  readonly label: string;
};

type ColumnHeaderRowProps = {
  readonly columns: ReadonlyArray<Column>;
  // Optional grid template applied to the columns wrapper. When omitted,
  // the columns share equal-width via `grid-cols-N` derived from count.
  readonly gridTemplate?: string;
  // When true, append a trailing 9x9 spacer so the header aligns with rows
  // ending in a trash affordance. 36px is the kit `Button`'s `size="icon"`
  // (`h-control-md`), which is what those rows now render — the app-local
  // `IconButton` this was originally sized against was deleted by IMM-741.7.
  readonly trailingActionSpacer?: boolean;
};

export function ColumnHeaderRow({ columns, gridTemplate, trailingActionSpacer = false }: ColumnHeaderRowProps) {
  const gridClass = gridTemplate ?? `grid-cols-${columns.length}`;
  const style = gridTemplate !== undefined ? { gridTemplateColumns: gridTemplate } : undefined;

  // -mt-3 self-pulls the row up so the gap to the modal divider above
  // shrinks from Modal's default py-6 (24px) to ~12px. The header is a
  // sparse uppercase label that visually sits high in its cell and
  // would otherwise look detached from the form rows below.
  return (
    <div className="-mt-3 flex items-baseline gap-2 px-1 text-xs uppercase tracking-wide text-text-tertiary">
      <div
        className={['grid flex-1 gap-2', gridTemplate === undefined ? gridClass : ''].filter((c) => c !== '').join(' ')}
        style={style}
      >
        {columns.map((col) => (
          <span key={col.label}>{col.label}</span>
        ))}
      </div>
      {trailingActionSpacer && <span aria-hidden className="h-9 w-9" />}
    </div>
  );
}
